import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUnfinishedCommands } from 'store/FileUploaderContext/selector';
import { updateCommandsStatus } from 'Common/Components/FileUploadContext/actions';
import isEmpty from 'lodash/isEmpty';

const CommandValidator = () => {
  const dispatch = useDispatch();
  const [previousTimeout, setPreviousTimeout] = useState(null);
  const commands = useSelector(selectUnfinishedCommands);

  useEffect(() => {
    if (!isEmpty(commands) && !previousTimeout) {
      const timeout = setTimeout(() => {
        setPreviousTimeout(null);
        dispatch(updateCommandsStatus());
      }, 3000);
      setPreviousTimeout(timeout);
    }
  }, [commands, dispatch, previousTimeout]);

  return null;
};

export default CommandValidator;
